export const AUTHTOKEN = "auth_token";
export const LOCAL = "local";

export const domainsConfig = {
  "localhost": {
    secretKey: "0191e9c0-bee0-718e-80a1-f977e5abcdcf",
    chatEnabled: true,
  },
  "mars-demo.enthalpytech.com": {
    secretKey: "01938be1-38bf-7c3f-ac01-4a52a8d065b0",
    chatEnabled: true,
  },
  "gamezone.sd.zain.com" : {
    secretKey: "0194080a-ca29-7a73-86d3-dd7858dc9521",
    chatEnabled: false,
  },
  "sd.gamezoone.com" : {
    secretKey: "0194cc09-8963-7189-aaac-204ee9f2976e",
    chatEnabled: false,
  },
  "gamezone-sd.enthalpytech.com" : {
    secretKey: "0194cc09-8963-7189-aaac-204ee9f2976e",
    chatEnabled: false,
  },
  "iq.gamezoone.com" : {
    secretKey: "0194cc09-f5b4-76dd-be2c-bf9c90673ac6",
    chatEnabled: false,
  },
  "gamezone-iq.enthalpytech.com" : {
    secretKey: "0194cc09-f5b4-76dd-be2c-bf9c90673ac6",
    chatEnabled: false,
  },
  "gamemall.enthalpytech.com" : {
    secretKey: "01954b0f-4fd6-7520-972f-272f86d4e3d1",
    chatEnabled: false,
  },
  "gamezone-ksa.enthalpytech.com" : {
    secretKey: "019620f5-5b56-7d8b-bb6e-83695bb70d8f",
    chatEnabled: false,
  },
  "ksa.gamezoone.com" : {
    secretKey: "019620f5-5b56-7d8b-bb6e-83695bb70d8f",
    chatEnabled: false,
  },
  "gamemmall.com": {
    secretKey: "0194ffaa-871e-73fe-b8e1-d6048a9b13f8",
    chatEnabled: false
  }
};

